import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { Equipe } from './models/equipe';
import { EquipeModel } from './models/equipe-model';
import { EquipeFind } from './models/equipe-find';

@Injectable({
  providedIn: 'root',
})
export class TeamsService {
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private http: HttpClient) {}

  addTeam(team: EquipeModel): Observable<EquipeModel> {
    return this.http
      .post<EquipeModel>(environment.sso + '/equipes/' + environment.selected.cnpj, team, this.httpOptions)
      .pipe(catchError(err => of(err.error)));
  }

  updateTeam(id: string, team: EquipeModel): Observable<EquipeModel> {
    return this.http
      .put<EquipeModel>(environment.sso + '/equipes/' + environment.selected.cnpj + '/' + id, team, this.httpOptions)
      .pipe(catchError(err => of(err.error)));
  }

  deleteTeam(id: string) {
    return this.http
      .delete(environment.sso + '/equipes/' + environment.selected.cnpj + '/' + id, this.httpOptions)
      .pipe(catchError(err => of(err.error)));
  }

  getTeams(): Observable<Equipe[]> {
    if (!environment.selected.cnpj) {
      return of([]);
    }

    return this.http
      .get<Equipe[]>(environment.sso + '/equipes/' + environment.selected.cnpj)
      .pipe(catchError(err => of(err.error)));
  }

  getTeam(id: string): Observable<Equipe> {
    if (id === '' || !environment.selected.cnpj) {
      return of();
    }

    return this.http
      .get<Equipe>(environment.sso + '/equipes/' + environment.selected.cnpj + '/' + id)
      .pipe(catchError(err => of(err.error)));
  }

  getUserTeams(userId: string): Observable<EquipeFind[]> {
    if (!environment.selected.cnpj) {
      return of([]);
    }

    return this.http
      .get<EquipeFind[]>(`${environment.sso}/equipes-find/${environment.selected.cnpj}/${userId}`)
      .pipe(catchError(err => of(err.error)));
  }
}
